import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import inViewportDirective from 'vue-in-viewport-directive'

Vue.config.productionTip = false;

// Smooth scrolling plugin
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

//Plugin to check i an element enters the viewpoint
Vue.directive('in-viewport', inViewportDirective);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

/* Copy email to clipboard */

    function copyToClipboard(text) {
        if (window.clipboardData && window.clipboardData.setData) {
            // IE specific code path to prevent textarea being shown while dialog is visible.
            // eslint-disable-next-line no-undef
            return clipboardData.setData("Text", text);

        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    var copyId = document.querySelector("#copy-mail");

    copyId.onclick = function() {
        copyToClipboard('hi@tobihoffmann.com');
        copyId.setAttribute("data", "copied");
    }

    var resetAttribute = function() {
        copyId.setAttribute("data", "click to copy");
    }

    copyId.onmouseout = function() {
        setTimeout(resetAttribute, 1000);
    }
